"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var BundleProductsModule_1 = require("../components/BundleProductsModule/BundleProductsModule");
var targetNode = document.querySelector('.bundle-products-module-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(BundleProductsModule_1.default, null), targetNode);
}
